const testimonials = [
  {
    id: 1,
    name: 'Drasti Shah',
    title: 'Data Engineer',
    org: 'Mi9 Retail',
    desc:
      'Hilag is very sincere, hardworking and an asset to the organization. He always keeps himself updated with new technologies and is a flawless programmer. He is creative in his attempts to designing as well as development and he makes sure to deploy the projects on time. Moreover, he is a good listener and empathetic towards his team mates. Here is wishing him good luck!',
    link:'https://www.linkedin.com/in/drasti-shah-380391135/',
  },
  {
    id: 2,
    name: 'Anish Mansabdar',
    title: 'Technical Project Manager',
    org: 'CogniTensor',
    desc:
      'Hilag is an amazing web developer. He is very creative and always comes up with new and amazing ideas on the table. The best part- he delivered always before time and is very punctual. ',
    link:'https://www.linkedin.com/in/anish-mansabdar-496499b0/',
  },
  {
    id: 3,
    name: 'Dhruv Shetty',
    title: 'Founder and CEO',
    org: 'Pyramid Developers',
    desc:
      'Mr. Shah worked as a and has displayed great skill and willingness to learn. Paired with his consistently motivated and driven attitude they have had a very positive effect on the company and its clients.The projects worked on by Mr. Shah have been done with the utmost care and technical ability and clients have provided positive feedback regarding them as well.In all, Mr. Shah has been an asset to our company and a pleasure to work with.',
    link:'https://www.linkedin.com/in/dhruv-k-shetty/',
  },
];
export default testimonials;
